export const commonValues = {
  typography: {
    fontFamily: 'Syne, sans-serif !important',
    button: {
      fontWeight: 500,
      textAlign: 'capitalize'
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
      xxl: 1536
    }
  }
}

export const commonComponentValues = {
  MuiButton: {
    styleOverrides: {
      root: () => ({
        // borderRadius: '2em',
        padding: '5px 14px 4px',
        '&.user-action': {
          padding: '2px 8px',
          fontWeight: 800
        }
      })
    }
  },
  MuiFilledInput: {
    styleOverrides: {
      root: {
        '&:before, &:after': {
          borderBottom: 'none !important'
        },
        '&:hover:before': {
          borderBottom: 'none'
        },
        '&.Mui-focused:after': {
          borderBottom: 'none'
        }
      }
    }
  },

  MuiFormControl: {
    styleOverrides: {
      root: {
        '&:not(.MuiTextField-root) .MuiInputLabel-root': {
          transform: 'translate(14px, 2px)',
          fontSize: '0.75rem'
        }
      }
    }
  },
  MuiDialog: {
    styleOverrides: {
      paperWidthMd: () => ({
        borderRadius: '16px'
      }),
      paperFullScreen: () => ({
        borderRadius: 0
      })
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      notchedOutline: () => ({
        border: 'none'
      })
    }
  },
  MuiAutocomplete: {
    styleOverrides: {
      paper: () => ({
        display: 'block',
        position: 'relative',
        height: '100%',
        elevation: false
      })
    }
  }
}

export const dynamicComponentValues = isBase => {
  return {
    MuiAppBar: {
      styleOverrides: {
        colorInherit: {
          backgroundColor: 'transparent !important'
        }
      },
      defaultProps: {
        color: 'inherit'
      }
    },
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: {
        root: {
          boxShadow: 'none',
          backgroundImage: 'none',
          '&.side-nav': {
            transition: 'none !important'
          }
        }
      }
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: isBase ? '#343a40' : '#adb5bd',
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'none',
            color: '#6c757d'
          },
          '&:disabled': {
            color: 'rgb(73,80,87)'
          }
        }
      }
    }
  }
}
